/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateHrisIntegrationRequest } from '../models/CreateHrisIntegrationRequest';
import type { HRISAuth } from '../models/HRISAuth';
import type { HRISConfigName } from '../models/HRISConfigName';
import type { HRISIntegration } from '../models/HRISIntegration';
import type { UpdateHrisIntegrationRequest } from '../models/UpdateHrisIntegrationRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HrisIntegrationService {

    /**
     * Return HRIS integration list
     * @returns HRISIntegration Success
     * @throws ApiError
     */
    public static listHrisIntegrations({
        type,
        includeAuth,
    }: {
        /**
         * Integration Type
         */
        type?: string,
        /**
         * Include auth
         */
        includeAuth?: boolean,
    }): CancelablePromise<Array<HRISIntegration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/hrisIntegration',
            query: {
                'type': type,
                'includeAuth': includeAuth,
            },
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Creates hris integration
     * @returns HRISIntegration Success
     * @throws ApiError
     */
    public static createHrisIntegration({
        requestBody,
    }: {
        requestBody: CreateHrisIntegrationRequest,
    }): CancelablePromise<HRISIntegration> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hrisIntegration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update hris integration
     * @returns HRISIntegration Success
     * @throws ApiError
     */
    public static updateHrisIntegration({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: UpdateHrisIntegrationRequest,
    }): CancelablePromise<HRISIntegration> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/hrisIntegration/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete HRIS integration
     * @returns any Success
     * @throws ApiError
     */
    public static deleteHrisIntegration({
        id,
    }: {
        /**
         * HRIS Integration id
         */
        id: number,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/hrisIntegration/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Test HRSI url
     * @returns any Success
     * @throws ApiError
     */
    public static testHrisUrl({
        requestBody,
    }: {
        requestBody: {
            auth?: HRISAuth;
            url?: string;
            configName?: HRISConfigName;
        },
    }): CancelablePromise<{
        result?: string;
        status?: string;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hrisIntegration/test',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Manually trigger Workday RaaS sync for all connected data sources
     * @returns any Success
     * @throws ApiError
     */
    public static syncHrisIntegration({
        id,
    }: {
        id: number,
    }): CancelablePromise<{
        result?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hrisIntegration/{id}/sync',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

}
